// NATIVE
import React, { useEffect, useState } from 'react';

// CUSTOM
import { Card, CardActionArea, CardMedia, Skeleton } from '@mui/material';
import { useDispatch } from 'react-redux';

// INSTALLED
import { getImageStore } from '../store/files';

export const CardActionImage = ({ urlImage, typeImage }: any) => {
  // DISPATCH
  const dispatch = useDispatch();

  // USE STATES
  const [logoUrl, setLogoUrl] = useState('');
  const [loading, setLoading] = useState(true);

  const getLogoImage = async (imageName: string) => {
    setLoading(true);
    const response = await dispatch(getImageStore(imageName, typeImage));

    if (response instanceof Blob) {
      const imageUrl = URL.createObjectURL(response);
      setLogoUrl(imageUrl);
    }
  };

  useEffect(() => {
    if (urlImage) {
      getLogoImage(urlImage);
    }
  }, [urlImage]);

  return (
    <Card sx={{ width: 350, marginTop: 5 }}>
      <CardActionArea>
        {loading && (
          <Skeleton
            variant="rectangular"
            width="100%"
            height={250}
            animation="wave"
            sx={{ borderRadius: 1 }}
          />
        )}

        <CardMedia
          component="img"
          height="250"
          sx={{
            objectFit: 'fill',
            display: loading ? 'none' : 'block', // ocultamos mientras carga
          }}
          image={logoUrl}
          alt="Q"
          onLoad={() => setLoading(false)}
          onError={() => setLoading(false)}
        />
      </CardActionArea>
    </Card>
  );
};

// // NATIVE
// import React, { useEffect, useState } from 'react';

// // CUSTOM
// import { Card, CardActionArea, CardMedia, CircularProgress, Box } from '@mui/material';
// import { useDispatch } from 'react-redux';

// // INSTALLED
// import { getImageStore } from '../store/files';

// export const CardActionImage = ({ urlImage, typeImage }: any) => {
//   // DISPATCH
//   const dispatch = useDispatch();

//   // USE STATES
//   const [logoUrl, setLogoUrl] = useState('');
//   const [loading, setLoading] = useState(true);

//   const getLogoImage = async (imageName: string) => {
//     setLoading(true);
//     const response = await dispatch(getImageStore(imageName, typeImage));

//     if (response instanceof Blob) {
//       const imageUrl = URL.createObjectURL(response);
//       setLogoUrl(imageUrl);
//     }
//   };

//   useEffect(() => {
//     if (urlImage) {
//       getLogoImage(urlImage);
//     }
//   }, [urlImage]);

//   return (
//     <Card sx={{ width: 350, marginTop: 5, position: 'relative' }}>
//       <CardActionArea>
//         {loading && (
//           <Box
//             sx={{
//               height: 250,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               width: '100%',
//               backgroundColor: 'rgba(255,255,255,0.7)',
//               zIndex: 1,
//             }}
//           >
//             <CircularProgress />
//           </Box>
//         )}

//         <CardMedia
//           component="img"
//           height="250"
//           sx={{ objectFit: 'fill' }}
//           image={logoUrl}
//           alt="Q"
//           onLoad={() => setLoading(false)}
//           onError={() => setLoading(false)} // en caso de error quitamos el loader
//         />
//       </CardActionArea>
//     </Card>
//   );
// };
